<div class="d-flex align-items-center">
    <input class="form-check-input checkbox defaultheight" [disabled]="isOnlyCustomer" (click)="removeWorkgroup(userWorkgroup.Guid)" type="checkbox" value="" [id]="userWorkgroup.Guid" checked>
    <label class="form-check-label opacity-100 text-truncate" for="flexCheckDefault">
        {{userWorkgroup.Name}}
    </label>
</div>